import {
    MtMailSettings,
    MtMailTemplate,
} from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"


export const setMailSettingList = (settingList: readonly MtMailSettings[]) => ({
    type: inferLiteral(types.MAIL_SETTING_LIST),
    settingList,
})
export const setMailSettingEdit = (setting: MtMailSettings) => ({
    type: inferLiteral(types.MAIL_SETTING_EDIT),
    setting,
})
export const setMailSettingReloadList = (value: boolean) => ({
    type: inferLiteral(types.MAIL_SETTING_RELOAD_LIST),
    value,
})


export const setMailTemplateList = (templateList: readonly MtMailTemplate[]) => ({
    type: inferLiteral(types.MAIL_TEMPLATE_LIST),
    templateList,
})
export const setMailTemplateEdit = (template: MtMailTemplate) => ({
    type: inferLiteral(types.MAIL_TEMPLATE_EDIT),
    template,
})
export const setMailTemplateReloadList = (value: boolean) => ({
    type: inferLiteral(types.MAIL_TEMPLATE_RELOAD_LIST),
    value,
})
export const setMailTemplateReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.MAIL_TEMPLATE_RELOAD_EDIT),
    value,
})
